import style from 'styled-components'

export const Form = style.form`
  margin-bottom: 3rem;
`
